import * as React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import FormHelperText from "@mui/material/FormHelperText";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const MultiSelect = ({
  value = [],
  onChange,
  options = [],
  placeholder = "Select options",
  error = false,
  helperText = "",
  disabled = false,
  stylePropos = {},
  required = false,
  id,
  name,
}) => {
  const theme = useTheme();

  const handleChange = (event) => {
    const {
      target: { value: selectedValue },
    } = event;
    
    // Handle both string and array values
    const newValue = typeof selectedValue === "string" 
      ? selectedValue.split(",") 
      : selectedValue;
    
    onChange({
      target: {
        name: name,
        value: newValue
      }
    });
  };

  return (
    <FormControl 
      fullWidth 
      error={error}
      disabled={disabled}
      required={required}
      sx={stylePropos}
    >
      <Select
        id={id}
        multiple
        value={value}
        onChange={handleChange}
        input={<OutlinedInput placeholder={placeholder} />}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {selected.map((value) => (
              <Chip 
                key={value} 
                label={value} 
                size="small"
                sx={{
                  backgroundColor: theme.palette.primary.main,
                  color: theme.palette.primary.contrastText,
                  '& .MuiChip-deleteIcon': {
                    color: theme.palette.primary.contrastText,
                  }
                }}
              />
            ))}
          </Box>
        )}
        MenuProps={MenuProps}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {error && helperText && (
        <FormHelperText>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
};

export default MultiSelect;
